import React from 'react';
import { Modal, Paper, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => {
    return {
        modal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        root: {
            width: '750px',
            padding: '56px',
            height: '400px',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',

            borderRadius: '10px',
            border: '2px solid #009ADE',
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px 0',
        },
        button: {
            width: '150px',
        },
        footer: {
            display: 'flex',
            gap: '100px',
            justifyContent: 'center',
        },
    };
});

interface CashCollectionHelpModalProps {
    isOpen: boolean;
    onClose: Function;
}

export const CashCollectionHelpModal = ({
    isOpen,
    onClose,
}: CashCollectionHelpModalProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Modal className={classes.modal} open={isOpen}>
            <Paper className={classes.root}>
                <div className={classes.header}>
                    <Typography variant='h3'>
                        {t('Remove money from cash cassette')}
                    </Typography>
                </div>
                <div className={classes.body}>
                    <Typography
                        align='center'
                        variant='h4'
                        style={{ fontWeight: 'normal' }}
                    >
                        {t('Please take all the money from the cassette.')}
                    </Typography>
                    <Typography
                        align='center'
                        variant='h4'
                        style={{ fontWeight: 'normal' }}
                    >
                        {t(
                            'You can either return the cassette now or at the end of cash collection before Submit action'
                        )}
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button
                        className={classes.button}
                        variant='primary'
                        onClick={() => {
                            onClose();
                        }}
                    >
                        <Typography variant='button'>
                            {t('I understand')}
                        </Typography>
                    </Button>
                </div>
            </Paper>
        </Modal>
    );
};
